import {
  GET_PRIVATE_MESSAGE,
  GET_PRIVATE_MESSAGE_FAILED,
  GET_PRIVATE_MESSAGE_SUCCESS,
  RESET_PRIVATE_MESSAGE,
  UPDATE_PRIVATE_MESSAGE,
  UPDATE_PRIVATE_MESSAGE_FAILED,
  UPDATE_PRIVATE_MESSAGE_SUCCESS,
} from "./actionTypes"

export const getPrivateMessage = params => ({
  type: GET_PRIVATE_MESSAGE,
  payload: params,
})

export const getPrivateMessageSuccess = response => ({
  type: GET_PRIVATE_MESSAGE_SUCCESS,
  payload: response,
})

export const getPrivateMessageFailed = error => ({
  type: GET_PRIVATE_MESSAGE_FAILED,
  payload: error,
})

export const updatePrivateMessage = params => ({
  type: UPDATE_PRIVATE_MESSAGE,
  payload: params,
})

export const updatePrivateMessageSuccess = response => ({
  type: UPDATE_PRIVATE_MESSAGE_SUCCESS,
  payload: response,
})

export const updatePrivateMessageFailed = error => ({
  type: UPDATE_PRIVATE_MESSAGE_FAILED,
  payload: error,
})

export const resetPrivateMessage = () => ({
  type: RESET_PRIVATE_MESSAGE,
  payload: {},
})
